/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignAvailabilityCheckResponseSchema = z.object({
	configured: z.boolean(),
	campaignConfigured: z.boolean(),
	hasSlotsInWindow: z.boolean(),
})

export type CampaignAvailabilityCheckResponseSchema = z.infer<typeof campaignAvailabilityCheckResponseSchema>
